import type { Options } from '@interstate/components/RadioButtonList';
import type { SelectInputOption } from '@interstate/components/SelectInput';
import type { MaskingConfig } from '@interstate/components/TextInput/Types/textInputBaseTypes';

export enum FMField {
    bookoutOrInvoice = 'bookoutOrInvoice',
    brakingMechanism = 'brakingMechanism',
    condition = 'condition',
    cost = 'cost',
    cylinders = 'cylinders',
    driveLine = 'driveLine',
    engine = 'engine',
    exteriorColor = 'exteriorColor',
    fuel = 'fuel',
    grossVehicleWeightRating = 'grossVehicleWeightRating',
    interiorColor = 'interiorColor',
    invoiceAmount = 'invoiceAmount',
    isAirConditioningIncluded = 'isAirConditioningIncluded',
    mileage = 'mileage',
    msrp = 'msrp',
    odometerMileageType = 'odometerMileageType',
    principalDriverName = 'principalDriverName',
    sellingPrice = 'sellingPrice',
    steeringMechanism = 'steeringMechanism',
    stockNumber = 'stockNumber',
    transmission = 'transmission',
    transmissionType = 'transmissionType',
    trim = 'trim',
    vehicleUse = 'vehicleUse',
    wholesaleBookSource = 'wholesaleBookSource',
    wholesaleValue = 'wholesaleValue',
    wholesaleValueType = 'wholesaleValueType'
}

export type FMNames = keyof typeof FMField;

export type FMGenerator<T> = {
    [key in FMNames]?: T;
};
export type FMForm = FMGenerator<string | number | boolean>;
export type FMValueTypes = FMForm[keyof FMForm];
export type FMTouchedInputs = FMGenerator<boolean>;
export type FMInputErrors = FMGenerator<string>;
export type FMErrors = { [key: string]: FMInputErrors };
export type FMProps = {
    initialValues: FMForm;
    values: FMForm;
    touched: FMTouchedInputs;
    error: FMInputErrors;
    formVersion?: number;
};
export type FMContext = {
    form: FMProps;
    canApply: boolean;
    changeHandler: (name: FMNames, value: FMValueTypes) => void;
    handleClick: (type: 'APPLY' | 'CANCEL') => void;
    hideDrawer: () => void;
    isStockEditable: boolean;
    handleClickEditStock: () => void;
    isTrimEditable: boolean;
    handleClickEditTrim: () => void;
    resetEditable: () => void;
    handleBlur: (name: FMNames, value: FMValueTypes) => void;
};
export type FormTextInputProps = {
    name: FMNames;
    label: string;
    inputSuffix?: string;
    masking?: MaskingConfig;
    // SxProps
    sx?: Record<string, object>;
    validator?: (value: number | string) => string;
    maxValue?: number;
    maxLength?: number;
    maxLengthErrorMessage?: string;
};

export type FormStockInputProps = {
    name: 'stockNumber';
    label: string;
};

export type FormSelectInputProps = {
    name: FMField;
    label: string;
    options: SelectInputOption[];
    errorMessage?: string;
    maxHeight?: string;
    placeholder?: string;
    disable?: boolean;
};

// New: Props for FormCheckBox component
export type FormCheckBoxProps = {
    name: FMNames;
    label: string;
    sx?: Record<string, object> | React.CSSProperties;
};

export type FormRadioButtonListProps = {
    name: FMField;
    label: string;
    options: Options[];
    inline?: boolean;
};

export type PaymentState = {
    actionForPayment: string;
    isCalculating: boolean;
    error: boolean;
};
